var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 32C78.6274 32 84 26.6274 84 20C84 13.3726 78.6274 8 72 8C65.3726 8 60 13.3726 60 20C60 26.6274 65.3726 32 72 32Z",
    stroke: "#130A09",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 60C30.6274 60 36 54.6274 36 48C36 41.3726 30.6274 36 24 36C17.3726 36 12 41.3726 12 48C12 54.6274 17.3726 60 24 60Z",
    stroke: "#130A09",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 88C78.6274 88 84 82.6274 84 76C84 69.3726 78.6274 64 72 64C65.3726 64 60 69.3726 60 76C60 82.6274 65.3726 88 72 88Z",
    stroke: "#130A09",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.36 54.04L61.68 69.96M61.64 26.04L34.36 41.96",
    stroke: "#130A09",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgShare;